// 由 EB view/admin/src/router/modules/businessZones.js 自动转换
import Layout from '@/layout/index.vue';
import type { RouteRecordRaw } from 'vue-router'
import { roterPre } from '@/setting';

export default {
  path: `${roterPre}/business-zones`,
  name: 'businessZones',
  meta: {
    title: '区域代理'
  },
  alwaysShow: true,
  component: Layout,
  children: [
    {
      path: 'index',
      name: 'businessZonesIndex',
      meta: {
        title: '区域列表'
      },
      component: () => import('@/views/businessZones/index.vue')
    },
    {
      path: 'create',
      name: 'businessZonesCreate',
      meta: {
        title: '添加区域',
        activeMenu: '/business-zones/index',
      },
      component: () => import('@/views/businessZones/create.vue')
    },
    {
      path: 'agents',
      name: 'businessZonesAgents',
      meta: {
        title: '代理人员'
      },
      component: () => import('@/views/businessZones/agents.vue')
    },
    {
      path: 'agent-review',
      name: 'businessZonesAgentReview',
      meta: {
        title: '代理审核'
      },
      component: () => import('@/views/businessZones/agentReview.vue')
    },
    {
      path: 'settings',
      name: 'businessZonesSettings',
      meta: {
        title: '代理设置'
      },
      component: () => import('@/views/businessZones/settings.vue')
    }
  ]
}
